import { createReducer } from '@reduxjs/toolkit';
import * as Actions from './actions';

export interface TooltipItem {
  Term: string;
  Definition: string;
}
export interface TooltipState {
  loading: boolean;
  error: null | Error;
  data: TooltipItem[];
}

const defaultTooltipState: TooltipState = {
  loading: false,
  error: null,
  data: []
};

const tooltipReducer = createReducer(defaultTooltipState, {
  [Actions.GET_TOOLTIPS]: state => {
    state.loading = true;
  },
  [Actions.GET_TOOLTIPS_FAIL]: (state, action) => {
    state.loading = false;
    state.error = action.error;
  },
  [Actions.GET_TOOLTIPS_SUCCESS]: (state, action) => {
    state.loading = false;
    state.data = action.payload.data;
  }
});

export default tooltipReducer;
